export default {
  appTitle: '寵物健康管理系統',
  appSubtitle: '🐾 您的數位寵物照護夥伴',
  createPetProfileDesc: '輕鬆建立寵物檔案，追蹤健康狀況，與照護者安全分享資訊。無論您身在何處，都能安心照顧您的毛孩。',
  getStarted: '開始使用',
  learnMore: '了解更多',
  signUp: '立即註冊',

  // Stats
  happyPets: '快樂的寵物',
  usersFamilies: '使用家庭',
  careProfiles: '照護檔案',
  satisfactionRate: '滿意度',

  // How It Works
  easiestWay: '最簡單的方式',
  howItWorks: '如何運作',
  howItWorksSubtitle: '只需三個簡單步驟，即可開始管理您寵物的健康和照護',
  forPetOwners: '對於寵物主人',
  forCaregivers: '對於照護者',

  // Steps for Pet Owners
  createPetProfile: '建立寵物檔案',
  createPetProfileDesc: '新增您寵物的詳細資訊，包括健康記錄、飲食習慣和照護需求',
  shareWithCaregivers: '分享給照護者',
  shareWithCaregiversDesc: '安全地與家人、朋友或專業照護者分享寵物資訊',
  travelWithPeace: '安心出遊',
  travelWithPeaceDesc: '知道您的寵物在您離開時得到最好的照顧，讓您放心旅行',

  // Steps for Caregivers
  accessPetDetails: '存取寵物詳情',
  accessPetDetailsDesc: '立即查看所有重要的寵物資訊和照護指南',
  followSchedules: '遵循時程表',
  followSchedulesDesc: '追蹤餵食時間、藥物和其他重要的照護任務',
  stayConnected: '保持聯繫',
  stayConnectedDesc: '與寵物主人溝通並分享更新',

  // Features
  whyChooseUs: '為什麼選擇我們',
  features: '核心功能',
  featuresSubtitle: '為您和您的寵物設計的全方位照護工具',
  
  featureTitle1: '全面的寵物檔案',
  featureDesc1: '儲存所有寵物資訊，包括健康記錄、疫苗接種、藥物等',
  
  featureTitle2: '安全分享',
  featureDesc2: '與照護者安全地分享寵物資訊，完全控制誰可以存取什麼',
  
  featureTitle3: '即時更新',
  featureDesc3: '獲取寵物健康和照護活動的即時通知',

  scheduleFeature: '時程管理',
  scheduleFeatureDesc: '追蹤餵食時間、藥物、獸醫預約和其他重要事件',

  healthFeature: '健康追蹤',
  healthFeatureDesc: '監控體重、疫苗接種、過敏和健康狀況',

  mobileFeature: '行動友善',
  mobileFeatureDesc: '隨時隨地在任何設備上存取您的寵物資訊',

  viewAllFeatures: '查看所有功能',

  // App Preview
  seamlessExperience: '無縫體驗',
  appPreviewTitle: '強大而直觀的介面',
  appPreviewDescription: '我們的應用程式旨在讓寵物照護變得簡單而愉快。所有功能都觸手可及。',
  
  multiUserAccess: '多使用者存取',
  multiUserAccessDesc: '與家人和照護者協作照顧您的寵物',
  
  healthTracking: '健康追蹤',
  healthTrackingDesc: '監控體重、疫苗接種和獸醫就診',
  
  premiumFeature: '進階功能',
  premiumFeatureDesc: '解鎖進階工具以獲得更好的寵物照護',

  petDashboard: '寵物控制台',
  dog: '狗',
  years: '歲',
  healthyStatus: '健康',
  nextFeeding: '下次餵食',
  nextMedication: '下次用藥',
  weight: '體重',
  nextVetVisit: '下次就診',
  profileCompletion: '檔案完成度',
  viewDetails: '查看詳情',
  updateProfile: '更新檔案',

  // Testimonials
  happyUsers: '滿意的使用者',
  testimonials: '使用者評價',
  testimonialsSubtitle: '看看其他寵物主人如何評價 Pet Care Note',

  testimonial1: '這個應用程式改變了我的寵物照護方式！我可以輕鬆追蹤所有寵物的健康記錄。',
  testimonial1Author: '莎拉·陳',
  testimonial1Role: '3隻貓的主人',

  testimonial2: '作為一名寵物保姆，這個應用程式讓我的工作變得更輕鬆。所有資訊都在一個地方！',
  testimonial2Author: '約翰·史密斯',
  testimonial2Role: '專業寵物保姆',

  testimonial3: '終於有一個應用程式可以滿足我所有的寵物照護需求。強烈推薦！',
  testimonial3Author: '艾蜜莉·強森',
  testimonial3Role: '2隻狗的主人',

  testimonial4: '分享功能非常適合與家人協調寵物照護。',
  testimonial4Author: '麥可·李',
  testimonial4Role: '家庭寵物主人',

  testimonial5: '我喜歡我可以追蹤我的狗的疫苗接種和獸醫預約。非常有組織！',
  testimonial5Author: '潔西卡·布朗',
  testimonial5Role: '1隻狗的主人',

  testimonial6: '這個應用程式對我的寵物照護業務來說是一個遊戲規則改變者。',
  testimonial6Author: '大衛·威爾森',
  testimonial6Role: '寵物照護專業人士',

  // CTA
  readyToStart: '準備好開始了嗎？',
  ctaTitle: '今天就開始您的寵物健康之旅',
  ctaDescription: '加入數千位信任 Pet Care Note 照顧他們毛孩的寵物主人',

  learnMoreAbout: '了解更多關於',
  aboutUs: '關於我們',
  contactSupport: '聯絡支援',
  privacyPolicy: '隱私政策',

  // Pet types
  corgi: '柯基犬',
  siameseCat: '暹羅貓',
  borderCollie: '邊境牧羊犬',
  caregiver: '照護者',
  location: '位置',
  home: '家中',
};